/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Typography, Container } from "@mui/material";
import { legalResources } from "./.resources";
import { useResources } from "../../../hooks/useResources";

const TermsAndConditions: React.FC = () => {
  // Language sync is handled globally in App.tsx
  const res = useResources(legalResources);
  
  return (
    <Container>
      <Typography variant="h4" style={{ paddingTop: "32px" }}>
        {res.termsAndConditionsTitle}
      </Typography>
      <br />
      <br />
      <Typography variant="h6">1. Introduction</Typography>
      <p>
        PLEASE READ THESE WEBSITE TERMS OF USE AND PRIVACY STATEMENT CAREFULLY
        BEFORE USING THE SOFTION SOLUTIONS LTD WEBSITE (THE "WEBSITE"). THESE
        WEBSITE TERMS OF USE (THE "TERMS OF USE") GOVERN YOUR ACCESS TO AND USE
        OF THE WEBSITE. IF YOU DO NOT AGREE TO ALL OF THE TERMS OF USE AND
        PRIVACY STATEMENT SET FORTH BELOW, DO NOT USE THE WEBSITE. BY ACCESSING
        OR USING THE WEBSITE, YOU AND THE BUSINESS ENTITY OR THE ORGANIZATION
        YOU REPRESENT ("YOU" OR "YOUR") INDICATE YOUR AGREEMENT TO BE BOUND BY
        THE TERMS OF USE.
      </p>
      <Typography variant="h6">2. Scope</Typography>
      <p>
        The Website Terms of Use govern your use of the Website and all
        applications, content, software, online localization and services
        (collectively, "Content") available via the Website, except to the
        extent such Content is the subject of a separate agreement. Note that
        Softion Solutions Ltd Software Products are governed solely by the
        License agreements (the "EULA") under which they are sold or licensed.
        Always check the downloaded product EULA to make certain that you do not
        infringe the intellectual property rights of Softion Solutions Ltd or
        others. Softion Solutions Ltd reserves the right to modify and update
        its Privacy Statement and Terms and Conditions as needs dictate and as
        legal requirements are updated. If and when a change is made to our
        Privacy Statement or Terms and Conditions, this page will be duly
        updated to reflect the change. Your continued use of the Website after
        any changes to these Privacy Statements/Terms and Conditions will mean
        that you accept those changes.
      </p>
      <Typography variant="h6">3. Privacy Statement</Typography>
      <p>
        Softion Solutions use of personal data is governed by the terms set
        forth in our comprehensive Privacy Policy.
      </p>
      <Typography variant="h6">
        4.Legal, Copyright, and Trademark Information
      </Typography>
      <p>
        All intellectual property rights associated with the Website and its
        Contents are the sole property of Softion Solutions Ltd. The Content is
        protected by the UK and International copyright laws. All Softion
        Software Ltd Service Marks so designated and all products referenced on
        the Website are either trademarks or registered trademarks of Softion
        Solutions Ltd. All custom graphics, icons, and other items that appear
        on the Website are trademarks, service marks or trade dress of Softion
        Solutions Ltd and may not be used in any manner without the express
        written consent of Softion Solutions Ltd. Softion Solutions Ltd has made
        every effort to supply third-party trademark information on the Website.
        All third party trademarks represented on this web site may be the
        property of their respective owners. Certain areas of the Website may
        contain other proprietary notices, conditions of use, and copyright
        information, the terms of which must be observed and followed. Except
        for the rights of use and other rights expressly granted by these Terms
        and Conditions, you may not copy, reproduce, modify, lease, loan, sell,
        create derivative works from, upload, transmit, or distribute the
        Intellectual Property of the Website in any manner without the prior
        written consent of Softion Solutions Ltd. Softion Solutions Ltd grants
        you a limited, personal, nontransferable, revocable license which cannot
        be sub-licensed to access and use the Website and its Content only in a
        manner expressly authorized by Softion Softions Ltd and the website
        Terms and Conditions. Except to the extent required by law, the Content
        made available on the Website may not be reverse-engineered, modified,
        reproduced, republished, translated into any language, re-transmitted in
        any form or by any means, resold or redistributed without the prior
        written consent of Softion Solutions Ltd. You may not make, sell, offer
        for sale, modify, reproduce, display, publicly perform, import,
        distribute, retransmit or otherwise use the Content in any way, unless
        expressly permitted to do so by Softion Solutions Ltd. This Website uses
        the following open source libraries: jQuery JavaScript Library (Open
        Source - MIT License) Copyright (c) jQuery Foundation and other
        contributors https://jquery.org/license/ facebook/react Library (Open
        Source - MIT License) Copyright (c) jQuery Foundation and other
        contributors https://github.com/facebook/react/blob/master/LICENSE
      </p>
      <Typography variant="h6">5. Termination</Typography>
      <p>
        Softion Solutions Ltd, at its sole discretion, may terminate YOUR access
        and use of all or any portion of the Website and its Content at any
        time, with or without cause. Upon such termination, you must immediately
        discontinue use of the Website.
      </p>
      <Typography variant="h6">6. Disclaimer of Warranties</Typography>
      <p>
        THE CONTENT PROVIDED ON THE WEBSITE AND ALL RELATED COMMUNICATIONS ARE
        PROVIDED ON AN "AS IS" BASIS AND ARE FOR INFORMATION PURPOSES ONLY. IN
        ADDITION, ALL WARRANTIES ARE HEREBY DISCLAIMED, INCLUDING THE IMPLIED
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON
        INFRINGEMENT. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED
        WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO YOU. The Content,
        including but not limited to localization tools, provided on the Website
        may contain technical inaccuracies or typographical errors. Content,
        including but not limited to pricing, subscription terms may be changed
        or updated without notice. Softion Solutions Ltd may also make
        improvements and/or changes in the products and/or the programs
        described in this information at any time without notice.
      </p>
      <Typography variant="h6">7. Downloads</Typography>
      <p>
        Every care is taken to ensure any files available for download from this
        site are free from viruses. However, Softion Solutions Ltd except no
        liability for the following losses or damage caused as a result of
        downloading files from this site: (a) loss of data; (b) loss of revenue
        or anticipated profits; (c) loss of business; (d) loss of opportunity;
        (e) loss of goodwill or injury to reputation; (f) losses suffered by
        third parties; or (g) any indirect, consequential, special or exemplary
        damages arising from the use of this site regardless of the form of
        action
      </p>
      <Typography variant="h6">8. Limitation of Liability</Typography>
      <p>
        To the extent permitted by applicable law, in no event shall Softion
        Solutions Ltd be liable for any special, incidental, indirect, or
        punitive and consequential damages (including, without limitation,
        damages for loss of business profits, business interruption, loss of
        business information, or any other pecuniary loss) arising out of the
        use of or inability to use the Website and associated Content, even if
        Softion Solutions Ltd has been advised of the possibility of such
        damages. You understand that the Content made available on the Website
        may produce inaccurate results. You assume full and sole responsibility
        for any use of the Website and its Content and bear the entire risk for
        failures or faults. You agree that regardless of the cause of failure or
        fault or the form of any claim, YOUR SOLE REMEDY AND SOFTION SOLUTIONS
        LTD'S SOLE OBLIGATION SHALL BE GOVERNED BY THIS AGREEMENT AND IN NO
        EVENT SHALL SOFTION SOLUTIONS'S LIABILITY EXCEED THE PRICE PAID TO
        SOFTION SOLUTIONS FOR THE SERVICES RENDERED VIA THE WEBSITE.
      </p>
      <Typography variant="h6">9. Indemnification</Typography>
      <p>
        You agree to indemnify and hold harmless Softion Solutions Ltd, its
        contractors, and its licensors, and their respective directors,
        officers, employees and agents from and against any and all claims and
        expenses, including attorneys' fees, arising out of your use of the
        Website, including but not limited to your violation of this Agreement.
      </p>
      <Typography variant="h6">10. Miscellaneous</Typography>
      <p>
        The website Terms and Conditions shall be construed, interpreted and
        governed by the laws of the United Kingdom. The website Terms and
        Conditions gives you specific legal rights; you may have others that
        vary from country to country. Softion Solutions Ltd reserves all rights
        not specifically granted in the website Terms and Conditions.
      </p>
      <Typography variant="h6">11. Copyright Notice</Typography>
      <p>
        Copyright © 2020 Softion Solutions Ltd. All rights reserved. Microsoft,
        Windows, Windows NT, Azure B2C, Access and Excel are trademarks or
        registered trademarks of Microsoft Corporation. Apple, iPhone, and iPad
        are trademarks or registered trademarks of Apple Inc. Google and Android
        are trademarks or registered trademarks of Google Inc. Linux® is the
        registered trademark of Linus Torvalds in the U.S. and other countries.
        All other trademarks or registered trademarks are property of their
        respective owners.
      </p>
    </Container>
  );
};

export default TermsAndConditions;
